/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DomesticV2MeInviteFriendsPostRequest } from '../models';
// @ts-ignore
import { DomesticV2MeTrackAbandonedSessionPost200Response } from '../models';
// @ts-ignore
import { DomesticV2MeTrackAbandonedSessionPost422Response } from '../models';
// @ts-ignore
import { DomesticV2MeTrackAbandonedSessionPostRequest } from '../models';
/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Invite friends via email
         * @param {DomesticV2MeInviteFriendsPostRequest} body Message and contact information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2MeInviteFriendsPost: async (body: DomesticV2MeInviteFriendsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('domesticV2MeInviteFriendsPost', 'body', body)
            const localVarPath = `/domestic/v2/me/invite_friends`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tracks when session is abandoned for the current user
         * @param {DomesticV2MeTrackAbandonedSessionPostRequest} [trackingParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2MeTrackAbandonedSessionPost: async (trackingParams?: DomesticV2MeTrackAbandonedSessionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/domestic/v2/me/track_abandoned_session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration)
    return {
        /**
         * Invite friends via email
         * @param {DomesticV2MeInviteFriendsPostRequest} body Message and contact information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2MeInviteFriendsPost(body: DomesticV2MeInviteFriendsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2MeInviteFriendsPost(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Tracks when session is abandoned for the current user
         * @param {DomesticV2MeTrackAbandonedSessionPostRequest} [trackingParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2MeTrackAbandonedSessionPost(trackingParams?: DomesticV2MeTrackAbandonedSessionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomesticV2MeTrackAbandonedSessionPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2MeTrackAbandonedSessionPost(trackingParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeApiFp(configuration)
    return {
        /**
         * Invite friends via email
         * @param {DomesticV2MeInviteFriendsPostRequest} body Message and contact information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2MeInviteFriendsPost(body: DomesticV2MeInviteFriendsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2MeInviteFriendsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Tracks when session is abandoned for the current user
         * @param {DomesticV2MeTrackAbandonedSessionPostRequest} [trackingParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2MeTrackAbandonedSessionPost(trackingParams?: DomesticV2MeTrackAbandonedSessionPostRequest, options?: any): AxiosPromise<DomesticV2MeTrackAbandonedSessionPost200Response> {
            return localVarFp.domesticV2MeTrackAbandonedSessionPost(trackingParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeApi - interface
 * @export
 * @interface MeApi
 */
export interface MeApiInterface {
    /**
     * Invite friends via email
     * @param {DomesticV2MeInviteFriendsPostRequest} body Message and contact information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApiInterface
     */
    domesticV2MeInviteFriendsPost(body: DomesticV2MeInviteFriendsPostRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Tracks when session is abandoned for the current user
     * @param {DomesticV2MeTrackAbandonedSessionPostRequest} [trackingParams] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApiInterface
     */
    domesticV2MeTrackAbandonedSessionPost(trackingParams?: DomesticV2MeTrackAbandonedSessionPostRequest, options?: AxiosRequestConfig): AxiosPromise<DomesticV2MeTrackAbandonedSessionPost200Response>;

}

/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI implements MeApiInterface {
    /**
     * Invite friends via email
     * @param {DomesticV2MeInviteFriendsPostRequest} body Message and contact information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public domesticV2MeInviteFriendsPost(body: DomesticV2MeInviteFriendsPostRequest, options?: AxiosRequestConfig) {
        return MeApiFp(this.configuration).domesticV2MeInviteFriendsPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tracks when session is abandoned for the current user
     * @param {DomesticV2MeTrackAbandonedSessionPostRequest} [trackingParams] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public domesticV2MeTrackAbandonedSessionPost(trackingParams?: DomesticV2MeTrackAbandonedSessionPostRequest, options?: AxiosRequestConfig) {
        return MeApiFp(this.configuration).domesticV2MeTrackAbandonedSessionPost(trackingParams, options).then((request) => request(this.axios, this.basePath));
    }
}
